import { createNgReactBridgeDirective } from '../../react-bridge'
import { OrganizationApplicationsSettingsForm } from '../../../components/organization-applications-settings-form'

export const organizationApplicationsSettingsForm =
  createNgReactBridgeDirective(
    'reactOrganizationApplicationsSettingsForm',
    [],
    OrganizationApplicationsSettingsForm,
    ['organizationUuid']
  )
